import { type Option, type StripePrice } from './types'

interface StripePriceLinksProps {
  prices: StripePrice[]
  selectedPriceIds: Option[]
}

const StripePriceLinks = ({ prices, selectedPriceIds }: StripePriceLinksProps) => {
  const selectedPrices = prices.filter((price) => selectedPriceIds.some((selectedPrice) => selectedPrice.value === price.id))

  return (
    <div className='flex items-center'>
      <span className='text-gray-400 tracking-tight mr-2'>Stripe Price IDs</span>
      {selectedPrices.map((price, index) => (
        <span key={price.id}>
          <a
            href={`https://dashboard.stripe.com/prices/${price.id}`}
            target='_blank'
            rel='noopener noreferrer'
            id={price.id}
            className='text-thatch-purple-primary'
          >
            {price?.product?.name}
          </a>
          {index < selectedPrices.length - 1 && (
            <span className='mx-1'>|</span>
          )}
        </span>
      ))}
      {selectedPrices.length > 0 && <span className='mx-1'>|</span>}
      <a
        href='https://dashboard.stripe.com/products/prod_ODnBsPrw0VTtCq'
        target='_blank'
        rel='noopener noreferrer'
        id='all_prices'
        className='text-thatch-purple-primary'
      >
        all prices
      </a>
    </div>
  )
}

export default StripePriceLinks
